// Messages for operator/settings/Roles (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.roles.head': 'Roles & Permissions — Operator',
  'operator.roles.back': 'Staff & Roles',
  'operator.roles.title': 'Roles & Permissions',
  'operator.roles.desc':
    'View system roles and compose custom roles from fine-grained permissions.',
  'operator.roles.new': 'New role',
  'operator.roles.system': 'system',
  'operator.roles.custom': 'custom',
  'operator.roles.lowest': 'lowest in hierarchy',
  'operator.roles.permission': '{count} permission',
  'operator.roles.permissions': '{count} permissions',
  'operator.roles.hint': 'Select a role to view its permissions, or create a custom role.',
  'operator.roles.name_placeholder': 'e.g. Dispatcher',
  'operator.roles.create': 'Create role',
  'operator.roles.save': 'Save changes',
  'operator.roles.delete': 'Delete role',
  'operator.roles.close': 'Close',
  'operator.roles.confirm_delete': 'Delete the “{name}” role?',
  'operator.roles.system_note':
    'System roles are seeded foundations — viewable but not editable. Create a custom role to compose your own permission set.',
  'operator.roles.ceiling_note': "You can't grant a permission your own role doesn't have.",
}

export const zhTW = {
  'operator.roles.head': '角色與權限 — 操作員',
  'operator.roles.back': '人員與角色',
  'operator.roles.title': '角色與權限',
  'operator.roles.desc': '檢視系統角色，並以細項權限組成自訂角色。',
  'operator.roles.new': '新增角色',
  'operator.roles.system': '系統',
  'operator.roles.custom': '自訂',
  'operator.roles.lowest': '階層最低',
  'operator.roles.permission': '{count} 項權限',
  'operator.roles.permissions': '{count} 項權限',
  'operator.roles.hint': '選擇角色以檢視其權限，或建立自訂角色。',
  'operator.roles.name_placeholder': '例如：派遣員',
  'operator.roles.create': '建立角色',
  'operator.roles.save': '儲存變更',
  'operator.roles.delete': '刪除角色',
  'operator.roles.close': '關閉',
  'operator.roles.confirm_delete': '刪除「{name}」角色？',
  'operator.roles.system_note':
    '系統角色為預設基礎 — 可檢視但不可編輯。請建立自訂角色以組成自己的權限集。',
  'operator.roles.ceiling_note': '無法授予您自身角色未具備的權限。',
}
